import styled from 'styled-components'

import CosplayGuide from '~/features/general-participation/components/CosplayGuide'
import PhotographerGuide from '~/features/general-participation/components/PhotographerGuide'
import Accordion from '~/shared/components/accordion/Accordion'

function CosplayInfo() {
  return (
    <Wrapper>
      <CosplayGuide />
      <PhotographerGuide />
      <Accordion
        title={'사진 촬영 가이드 및 코스프레 복장 가이드 보기'}
        contents={
          '사진 촬영 가이드 및 코스프레 복장 가이드 보기 사진 촬영 가이드 및 코스프레 복장 가이드 보기 사진 촬영 가이드 및 코스프레 복장 가이드 보기 사진 촬영 가이드 및 코스프레 복장 가이드 보기'
        }
      />
    </Wrapper>
  )
}

export default CosplayInfo

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 36px;
`
